import ManagerSelectProxy from '@/proxies/Manager/ManagerSelectProxy';

export default {
  data() {
    return {
      useNullableManager: true,
      managers: [],
    };
  },
  mounted() {
    this.getManagers();
  },
  computed: {
    managersItems() {
      const selectList = [];
      if (this.useNullableManager) {
        selectList.push({
          text: this.lang(this.$store, 'sap/listings.global.filter.statuses.all'),
          value: null,
        });
      }

      for (const manager of this.managers) {
        selectList.push({
          text: manager.name,
          value: manager.id,
        });
      }
      return selectList;
    },

  },
  methods: {
    getManagers() {
      new ManagerSelectProxy()
        .setParameters({})
        .all()
        .then((response) => {
          this.managers = response.data.data.managers;
          this.$forceUpdate();
          // console.log(response.data.data.managers);
        })
        .catch((error) => {
          console.warn(error);
          this.paginatedObject = {};
        })
        .finally(() => {
          this.isTableLoading = false;
          this.isRequestingNow = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },

  },
};
